import React from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Privacidad() {
  return (
    <LegalLayout title="Política de Privacidad" updated="Junio de 2026">
      <p data-testid="privacidad-intro" className="text-[15px]" style={{ color: "#444" }}>
        En Vinonotas nos tomamos en serio la privacidad de tus datos. Esta política explica qué información
        recopilamos, cómo la utilizamos y qué derechos tienes sobre ella.
      </p>

      <LegalSection title="1. Datos que recopilamos">
        <p>
          Recopilamos los datos que nos proporcionas al registrarte (nombre y correo electrónico), las notas de
          cata, vinos e imágenes que creas, y datos técnicos básicos necesarios para el funcionamiento del
          servicio.
        </p>
      </LegalSection>

      <LegalSection title="2. Uso de la información">
        <p>
          Utilizamos tus datos para prestar y mejorar el servicio, mantener tu cuenta, generar tus fichas y
          estadísticas, y comunicarnos contigo cuando sea necesario. No vendemos tus datos personales a terceros.
        </p>
      </LegalSection>

      <LegalSection title="3. Asistente de IA">
        <p>
          Cuando utilizas el asistente Somm Vinonotas, el contexto de tu ficha de cata puede enviarse a nuestro
          proveedor de inteligencia artificial para generar respuestas. No se emplea para identificarte
          personalmente.
        </p>
      </LegalSection>

      <LegalSection title="4. Conservación y seguridad">
        <p>
          Conservamos tus datos mientras tu cuenta esté activa. Aplicamos medidas técnicas y organizativas
          razonables para proteger la información frente a accesos no autorizados. Las contraseñas se almacenan
          cifradas.
        </p>
      </LegalSection>

      <LegalSection title="5. Cookies y almacenamiento local">
        <p>
          Utilizamos cookies estrictamente necesarias para mantener tu sesión iniciada y almacenamiento local del
          navegador para recordar la verificación de edad. No utilizamos cookies con fines publicitarios.
        </p>
      </LegalSection>

      <LegalSection title="6. Tus derechos">
        <p>
          Puedes acceder, rectificar o eliminar tus datos personales, así como solicitar la supresión de tu
          cuenta. Para ejercer estos derechos, contáctanos a través de los canales oficiales de Vinonotas.
        </p>
      </LegalSection>

      <LegalSection title="7. Menores de edad">
        <p>
          El servicio está dirigido exclusivamente a personas mayores de la edad legal para consumir alcohol. No
          recopilamos conscientemente datos de menores de edad.
        </p>
      </LegalSection>

      <LegalSection title="8. Cambios en esta política">
        <p>
          Podremos actualizar esta Política de Privacidad periódicamente. Publicaremos cualquier cambio en esta
          misma página con su fecha de actualización.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
